module.exports = __webpack_public_path__ + "img/back4.0dedddc5.png";